import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { parsePhoneNumberFromString } from 'libphonenumber-js';

import { phoneNumbers } from './phone-numbers';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InputPhoneComponent {
  @Input() label: string = 'Teléfono';
  @Input() value: string | null = null;
  @Input() placeholder!: string;
  @Output() valueChange = new EventEmitter<string>();

  phoneNumbers = phoneNumbers;
  // tel: string = '+57';
  countryCode: any = 'CO';
  userPhone: string = '';

  countryPrefix: string = '+57';
  tel: string = '+57';

  constructor() {}

  parsePhoneNumber(event: any) {
    const inputValue = event.target.value;
    this.tel = inputValue;

    try {
      const phoneNumber = parsePhoneNumberFromString(inputValue);

      if (!phoneNumber) {
        console.warn('Número no válido o sin país detectado.');
        return;
      }

      if (phoneNumber.isValid()) {
        const detectedCountry = phoneNumber.country;
        this.countryCode = detectedCountry;
        this.userPhone = phoneNumber.number;
        this.emitValue();
      } else {
        console.warn('El número no es válido.');
      }
    } catch (error) {
      console.error('Error al parsear el número:', error);
    }
  }

  get selectedFlag(): string {
    const selected = this.phoneNumbers.find(
      (p) => p.country === this.countryCode,
    );
    return selected ? selected.flag : '';
  }

  emitValue() {
    this.valueChange.emit(this.userPhone);
  }

  onCountryChange() {
    const selectedCountry = this.phoneNumbers.find(
      (p) => p.country === this.countryCode,
    );

    if (selectedCountry) {
      this.countryPrefix = selectedCountry.code;
      this.tel = this.countryPrefix;
      this.userPhone = this.tel;
      this.emitValue();
    }
  }

  getSelectedCountryText(): string {
    const selected = this.phoneNumbers.find(
      (p) => p.country === this.countryCode,
    );
    return selected ? `${selected.country}` : 'Selecciona un país';
  }

  onPhoneInput(event: any) {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/[^\d+]/g, '');

    if (value.includes('+')) {
      value = '+' + value.replace(/\+/g, '');
    }

    if (!value.startsWith(this.countryPrefix)) {
      value =
        this.countryPrefix +
        value.replace(/^\+?\d*/, '');
    }

    const phoneNumber = value
      .substring(this.countryPrefix.length)
      .replace(/\D/g, '');

    this.tel = this.countryPrefix + phoneNumber;

    input.value = this.tel;

    this.userPhone = this.tel;
    this.emitValue();
  }

}
